export const TOP_MENU = [
  {
    name: 'NAVIGATION.HOME',
    route: '/',
    children: [
      {
        name: 'NAVIGATION.DASHBOARD',
        icon: 'mdi-tablet-dashboard',
        route: '/',
      },
      /*
      {
        name: 'NAVIGATION.GOOGLE_ADS',
        icon: 'mdi-chart-bar',
        route: '/dashboard/google-ads',
      },
      {
        name: 'NAVIGATION.FACEBOOK_ADS',
        icon: 'mdi-chart-bar',
        route: '/dashboard/facebook-ads',
      },
      */
    ],
  },
  {
    name: 'NAVIGATION.SALES',
    route: '/sales',
    children: [
      {
        name: 'NAVIGATION.NEW_SALE',
        icon: 'mdi-cash',
        route: '/sales/new-sale',
      },
      {
        name: 'NAVIGATION.DAILY_SALES',
        icon: 'mdi-cash-multiple',
        route: '/sales/daily-sales',
      },
      /*
      {
        name: 'NAVIGATION.SALE_REQUESTS',
        icon: 'mdi-cash-multiple',
        route: '/sales/sale-requests',
      },
      */
    ],
  },
  {
    name: 'NAVIGATION.OPERATIONS',
    route: '/operations',
    children: [
      {
        name: 'NAVIGATION.CONFIRMATION_TRACKING',
        icon: 'mdi-find-replace',
        route: '/operations/confirmation-tracking',
      },
      {
        name: 'NAVIGATION.CHANGE_CANCEL',
        icon: 'mdi-find-replace',
        route: '/operations/changes-cancellations',
      },
      /*
      {
        name: 'NAVIGATION.COST_REGULATION',
        icon: 'mdi-find-replace',
        route: '/operations/cost-regulation',
      },
      {
        name: 'NAVIGATION.EDITING_SALE_DATES',
        icon: 'mdi-find-replace',
        route: '/operations/sale-date',
      },
      {
        name: 'NAVIGATION.FORECAST',
        icon: 'mdi-find-replace',
        route: '/operations/forecast',
      },
      {
        name: 'NAVIGATION.DETAILED_FORECAST',
        icon: 'mdi-find-replace',
        route: '/operations/detailed-forecast',
      },
      {
        name: 'NAVIGATION.INHOUSE_REPORT',
        icon: 'mdi-find-replace',
        route: '/operations/inhouse-report',
      },
      {
        name: 'NAVIGATION.CHECKIN_REPORT',
        icon: 'mdi-find-replace',
        route: '/operations/checkin-report',
      },
      {
        name: 'NAVIGATION.DISCOUNT_REPORT',
        icon: 'mdi-find-replace',
        route: '/operations/discount-report',
      },
      */
    ],
  },
  {
    name: 'NAVIGATION.PRODUCTS',
    route: '/products',
    children: [
      {
        name: 'NAVIGATION.PROPERTIES',
        icon: 'mdi-bed',
        route: '/products/properties',
      },
      {
        name: 'NAVIGATION.CANCELLATION_INSURANCES',
        icon: 'mdi-bus-school',
        route: '/products/cancellation-insurances',
      },
      /*
      {
        name: 'NAVIGATION.TOURS',
        icon: 'mdi-bus-school',
        route: '/products/tours',
      },
      {
        name: 'NAVIGATION.TRANSFERS',
        icon: 'mdi-bus-school',
        route: '/products/transfers',
      },
      {
        name: 'NAVIGATION.BUS_TRANSFERS',
        icon: 'mdi-bus-school',
        route: '/products/bus-transfers',
      },
 
      {
        name: 'NAVIGATION.ADDITIONAL_SERVICES',
        icon: 'mdi-bus-school',
        route: '/products/additional-services',
      },
      */
    ],
  },
  {
    name: 'NAVIGATION.ACCOUNTING',
    route: '/accounting',
    children: [
      {
        name: 'NAVIGATION.PAYMENT_CONFIRMATION',
        icon: 'mdi-format-list-checks',
        route: '/accounting/payment-confirmation',
      },
      {
        name: 'NAVIGATION.BALANCE_PAYMENT_REPORT',
        icon: 'mdi-cash-multiple',
        route: '/accounting/balance-payment-report',
      },
      {
        name: 'NAVIGATION.SPECIAL_DISCOUNTS',
        icon: 'mdi-sale',
        route: '/accounting/special-discounts',
      },
      /*
      {
        name: 'NAVIGATION.EXPENSES',
        icon: 'mdi-currency-eur',
        route: '/accounting/expenses',
      },
      {
        name: 'NAVIGATION.RETURN_DEDUCTION_REPORT',
        icon: 'mdi-currency-eur',
        route: '/accounting/return-deduction-reports',
      },
      {
        name: 'NAVIGATION.BANKS_AND_CARDS',
        icon: 'mdi-currency-eur',
        route: '/accounting/banks-cards',
        children: [
          {
            name: 'NAVIGATION.EXCHANGE_RATES',
            icon: 'mdi-currency-eur',
            route: '/accounting/exchange-rates',
          },
          {
            name: 'NAVIGATION.CASH_FLOW',
            icon: 'mdi-currency-eur',
            route: '/accounting/cash-flow',
          },
          {
            name: 'NAVIGATION.BANKS',
            icon: 'mdi-currency-eur',
            route: '/accounting/banks',
          },
          {
            name: 'NAVIGATION.CREDIT_CARDS',
            icon: 'mdi-currency-eur',
            route: '/accounting/credit-cards',
          },
        ],
      },
      */
    ],
  },

  {
    name: 'NAVIGATION.REPORTS',
    route: '/reports',
    children: [
      {
        name: 'NAVIGATION.SALE_REPORT',
        icon: 'mdi-poll-box',
        route: '/reports/sales',
        children: [
          {
            name: 'NAVIGATION.TURNOVER_REPORT',
            icon: 'mdi-poll-box',
            route: '/reports/turnover',
          },
          {
            name: 'NAVIGATION.HOTEL_SALES_REPORT',
            icon: 'mdi-poll-box',
            route: '/reports/hotel-sales',
          },
          {
            name: 'NAVIGATION.HOTEL_TURNOVER_REPORT',
            icon: 'mdi-poll-box',
            route: '/reports/hotel-turnover',
          },
          {
            name: 'NAVIGATION.COMPANY_TURNOVER_REPORT',
            icon: 'mdi-poll-box',
            route: '/reports/company-turnover',
          },
          /*
      
          {
            name: 'NAVIGATION.PRODUCT_TURNOVER_REPORT',
            icon: 'mdi-poll-box',
            route: '/reports/product-turnover',
          },
          */
        ],
      },
      {
        name: 'NAVIGATION.FORECAST',
        icon: 'mdi-find-replace',
        route: '/reports/forecast',
      },

      {
        name: 'NAVIGATION.CANCELLATION_REPORT',
        icon: 'mdi-poll-box',
        route: '/reports/cancellation',
      },
      /*
 
      {
        name: 'NAVIGATION.EARLY_BOOKING_REPORT',
        icon: 'mdi-poll-box',
        route: '/reports/early-booking',
      },
      
      {
        name: 'NAVIGATION.ADDITIONAL_SERVICE_REPORT',
        icon: 'mdi-poll-box',
        route: '/reports/additional-service',
      },
      {
        name: 'NAVIGATION.TRANSFER_REPORTS',
        icon: 'mdi-poll-box',
        route: '/reports/transfer',
        children: [
          {
            name: 'NAVIGATION.CITY_SALES_REPORT',
            icon: 'mdi-poll-box',
            route: '/reports/city-sales',
          },
          {
            name: 'NAVIGATION.SALES_AD_REPORT',
            icon: 'mdi-poll-box',
            route: '/reports/sales-ad',
          },
          {
            name: 'NAVIGATION.TRANSFER_SALES_REPORT',
            icon: 'mdi-poll-box',
            route: '/reports/transfer-sales',
          },
          {
            name: 'NAVIGATION.BUS_TRANSFER_SALES_REPORT',
            icon: 'mdi-poll-box',
            route: '/reports/bus-transfer-sales',
          },
          {
            name: 'NAVIGATION.FLIGHT_SALES_REPORT',
            icon: 'mdi-poll-box',
            route: '/reports/flight-sales',
          },
        ],
      },
      */
    ],
  },
  {
    name: 'NAVIGATION.WEB_MANAGEMENT',
    route: '/web-management',
  },
  {
    name: 'NAVIGATION.MANAGEMENT',
    route: '/management',
    children: [
      {
        name: 'NAVIGATION.USER_ROLE_MANAGEMENT',
        icon: 'mdi-account-group',
        route: '/management/user-roles',
      },
      {
        name: 'NAVIGATION.USER_MANAGEMENT',
        icon: 'mdi-account-multiple',
        route: '/management/users',
      },
      {
        name: 'NAVIGATION.GLOBAL_DEFINITIONS',
        icon: 'mdi-content-save-settings',
        route: '/management/definitions',
        children: [
          {
            name: 'NAVIGATION.ROOM_TYPE_DEFINITIONS',
            icon: 'mdi-bed',
            route: '/management/definitions/room-types',
          },
          {
            name: 'NAVIGATION.ROOM_CLASS_DEFINITIONS',
            icon: 'mdi-bed',
            route: '/management/definitions/room-classes',
          },
          {
            name: 'NAVIGATION.VIEW_TYPE_DEFINITIONS',
            icon: 'mdi-image',
            route: '/management/definitions/view-types',
          },
          {
            name: 'NAVIGATION.ROOM_AREA_TYPE_DEFINITIONS',
            icon: 'mdi-home-map-marker',
            route: '/management/definitions/room-area-types',
          },
          {
            name: 'NAVIGATION.ROOM_FEATURE_AMENITY_DEFINITIONS',
            icon: 'mdi-star-circle-outline',
            route: '/management/definitions/room-feature-amenities',
          },
          {
            name: 'NAVIGATION.BOARD_TYPE_DEFINITIONS',
            icon: 'mdi-food-fork-drink',
            route: '/management/definitions/board-types',
          },
          {
            name: 'NAVIGATION.BED_TYPE_DEFINITIONS',
            icon: 'mdi-bed',
            route: '/management/definitions/bed-types',
          },
          {
            name: 'NAVIGATION.BED_SIZE_DEFINITIONS',
            icon: 'mdi-bed',
            route: '/management/definitions/bed-sizes',
          },
          {
            name: 'NAVIGATION.PROPERTY_CATEGORY_DEFINITIONS',
            icon: 'mdi-domain',
            route: '/management/definitions/property-categories',
          },
          {
            name: 'NAVIGATION.PACKAGE_FEATURE_DEFINITIONS',
            icon: 'mdi-package',
            route: '/management/definitions/package-features',
          },
          {
            name: 'NAVIGATION.CANCELLATION_POLICY_TYPE_DEFINITIONS',
            icon: 'mdi-text-box-check-outline',
            route: '/management/definitions/cancellation-policies',
          },
          {
            name: 'NAVIGATION.RATE_PLAN_TYPE_DEFINITIONS',
            icon: 'mdi-format-list-bulleted-type',
            route: '/management/definitions/rate-plans',
          },
        ],
      },
      /*
      {
        name: 'NAVIGATION.BANK_ACCOUNT_MANAGEMENT',
        icon: 'mdi-bank',
        route: '/management/bank-accounts',
      },
      {
        name: 'NAVIGATION.PAYMENT_GATEWAY_MANAGEMENT',
        icon: 'mdi-credit-card',
        route: '/management/payment-gateways',
      },
      {
        name: 'NAVIGATION.BANK_CARD_MANAGEMENT',
        icon: 'mdi-credit-card',
        route: '/management/bank-cards',
      },
      */
      {
        name: 'NAVIGATION.PAYMENT_OPTION_GROUPS',
        icon: 'mdi-credit-card',
        route: '/management/payment-option-groups',
      },

      {
        name: 'NAVIGATION.MARKET_MANAGEMENT',
        icon: 'mdi-map-marker',
        route: '/management/markets',
      },
      {
        name: 'NAVIGATION.PROPERTY_GROUPS_MANAGEMENT',
        icon: 'mdi-hotel',
        route: '/management/property-groups',
      },
      {
        name: 'NAVIGATION.COMPANY_MANAGEMENT',
        icon: 'mdi-city',
        route: '/management/companies',
      },
      {
        name: 'NAVIGATION.COMPANY_MARGIN_MANAGEMENT',
        icon: 'mdi-city',
        route: '/management/company-margins',
      },
      {
        name: 'NAVIGATION.INTEGRATIONS',
        icon: 'mdi-axis-arrow-lock',
        route: '/management/integrations',
        /*
        children: [
          {
            name: 'NAVIGATION.CHANNEL_MANAGER',
            icon: 'mdi-axis-arrow-lock',
            route: '/management/integrations/channel-managers',
          },
          {
            name: 'NAVIGATION.OTA',
            icon: 'mdi-axis-arrow-lock',
            route: '/management/integrations/otas',
          },
          {
            name: 'NAVIGATION.METASEARCH',
            icon: 'mdi-axis-arrow-lock',
            route: '/management/integrations/metasearches',
          },
        ],
        */
      },
      /*      {
              name: 'NAVIGATION.PROPERTY_GROUP_MANAGEMENT',
              icon: 'mdi-group',
              route: '/management/property-groups'
            }*/
    ],
  },
];
